/**
 * File: useCrmSettingsQueries.ts
 * Path: apps/admin/src/shared/hooks/useCrmSettingsQueries.ts
 * Description: The sales settings (stale-lead limits, daily goal) for the
 * Today page and Settings > Sales.
 */

import { useQuery } from "@tanstack/react-query";
import { FIRESTORE_COLLECTIONS } from "@idk/config";
import { DEFAULT_CRM_SETTINGS } from "../utils/todayListUtils";
import { crmSettingsRepo } from "../services/crmSettingsService";

export const crmSettingsKey = [FIRESTORE_COLLECTIONS.crmSettings] as const;

/** Settings, or the defaults while loading or when they can't be read. */
export const useCrmSettings = () => {
  const query = useQuery({ queryKey: crmSettingsKey, queryFn: crmSettingsRepo.get });
  return { ...query, settings: query.data ?? DEFAULT_CRM_SETTINGS };
};
